import { createTheme } from "@mui/material";

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#001B60'
        },
        secondary: {
            main: '#EA7F22'
        },
        success: {
            main: '#61EBA9'
        },
        error: {
            main: '#FF7765'
        },
        warning: {
            main: '#FEB173'
        },
        info: {
            main: '#FFFFFF'
        }

    },
    components: {
        MuiInputBase: {
            defaultProps: {
            },
            styleOverrides: {
                root: {
                    backgroundColor: '#F5F5F5',
                    borderRadius: '2px'
                }    
            }
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    backgroundColor: '#001B60'
                }
            }
        }
    }
})